export const environment = {
  production: false,
  apiUrl: 'https://wsqa.frakcio.com/api/v1/admin',
  MAX_INVITATIONS: 10,
};
